enum TourStep {
  AddEffect,
  RecordVideo,
  CreateNew,
  ViewExamples,
  SaveAndRestore,
  Help
}

export default TourStep;



// WEBPACK FOOTER //
// ./src/tour/TourSteps.ts